/**
 * stencil.cloud — Entry Point
 */

import { init } from './editor/app.js';

// Wait for DOM, then initialize the editor
document.addEventListener('DOMContentLoaded', init);
